$(function(){
	$('.top-video .player-nav a.play').click(function(){
		$('#video').trigger('play');
	});
	$('.top-video .player-nav a.pause').click(function(){
		$('#video').trigger('pause');
	});
	$('.bestsellers-block .list').slick({
	  speed: 300,
	  slidesToShow: 4,
	  slidesToScroll: 1,
	  responsive: [
	    {
	      breakpoint: 992,
	      settings: {
	        slidesToShow: 3
	      }
	    },
	    {
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 2
	      }
	    },
	    {
	      breakpoint: 576,
	      settings: {
	        slidesToShow: 1
	      }
	    }
	  ]
	});
});